<app-content-loading *ngIf="isLoading"></app-content-loading>

<div *ngIf="groups?.length && !isLoading">
    <div class="card card-xl mb-3" *ngFor="let group of groups">

        <div class="card-header">
            <h5 class="card-title">
                {{ group.name | localize }} ({{ group.items.length}})
            </h5>
        </div>

        <div class="card-body card-body-list">
            <div class="list-group fw-normal">
                <a class="list-group-item list-group-item-action" routerLink="/projects/{{project.Id}}/candidates/{{candidate.Id}}" *ngFor="let candidate of group.items">

                    <div class="row flex-sm-nowrap">

                        <div class="col-12 col-sm-auto mb-4 mb-sm-0">
                            <sc-avatar [user]="candidate" size="sm"></sc-avatar>
                        </div>

                        <div class="col col-shrink ms-n2">

                            <div class="row">

                                <div class="col col-shrink">

                                    <div class="align-items-center d-flex">
                                        <div class="d-inline-block candidate-name mb-0 me-3 fw-bold">{{ candidate.FirstName }} {{
                                            candidate.LastName }}
                                        </div>                                     
                                    </div>

                                    <p class="small text-muted job-title mb-0 fw-normal oneline">{{ candidate.JobTitle
                                        }}<span *ngIf="candidate.Company"> @ {{ candidate.Company }}</span></p>

                                </div>
                            </div>
                        </div>
                    </div>

                </a>
                <!-- <div class="list-group-item list-group-item-action">
            <div class="row align-items-center">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-dark" (click)="startModal.show(project)">{{ texts.startSourcing | localize }} <i
                    class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
              </div>
            </div>
          </div> -->
            </div>
        </div>
    </div>
</div>


@if (!isLoading)
{

@if (!groups?.length && (project.Status == 'Sourcing' || project.Status == 'AwaitingSourcing'))
{
<div class="row">
    <div class="col-12">
        <div class="card" >            
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <p class="mb-0 text-muted">
                            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> Das Projekt läuft! Du wirst benachrichtigt, wenn Bewerbungen eintreffen.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}

@if (project.Status == 'Imported' || project.Status == 'AnalysisRequested' || project.Status == 'AwaitingOrder')
{
<div class="row">
    <div class="col-12">
        <div class="card" >            
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <p class="mb-0 text-muted">
                            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> {{ texts.noCandidates | localize }}
                        </p>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-dark" (click)="startModal.show(project)">Starten <i
            class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-start-project #startModal [language]="loc.language"></app-modal-start-project>
}
}